import MFHeroGraphSkeleton from './MFHeroGraphSkeleton'

export default function MFHeroSectionSkeleton() {
  return (
    <div className='flex flex-col w-full px-5 bg-white rounded-[12px] h-[499px]'>
      <div className='pt-6 pb-2 flex gap-4'>
        {/* PowerForm Skeleton */}
        <div className='h-10 w-10 skeleton rounded-[50%]' />
        <div className='flex flex-col'>
          <div className='skeleton w-[80px] h-[13px] mb-[10px] rounded-[4px]' />
          <div className='skeleton w-[120px] h-[22px] rounded-[4px]' />
        </div>
      </div>

      <div className='pb-8 flex gap-4'>
        {/* PowerForm Skeleton */}
        <div className='h-4 w-10 skeleton rounded-[4px]' />
        <div className='flex flex-col '>
          <div className='skeleton w-[120px] h-[22px] rounded-[4px]' />
        </div>
      </div>

      <hr className='bg-[#EBF2F2] opacity-70' />

      <div className='flex flex-col'>
        <div className='text-[#6A6E6E] pt-2 pb-2 pl-1 text-13 skeleton w-[100px] h-2 mt-5 mb-3' />

        {/* HeroGraph Skeleton */}
        <div className='w-full h-[250px] mb-3'>
          <MFHeroGraphSkeleton />
        </div>
      </div>

      <div className='flex gap-3 mt-[2px] h-[36px]'>
        {/* Tabs Skeleton */}
        <div className='flex-1 flex gap-1 h-full'>
          <div className='skeleton flex-1 h-full rounded-[12px]' />
          <div className='skeleton flex-1 h-full rounded-[12px]' />
          <div className='skeleton flex-1 h-full rounded-[12px]' />
        </div>

        {/* Button Skeleton (Replaced with div) */}
        <div className='w-[120px]'>
          <div className='skeleton w-full h-full rounded-[12px]' />
        </div>
      </div>
    </div>
  )
}
